<template>
  <div class="container__">
    <img :src="imgSrc" width="100%" height="100%" class="bg__img" alt="" />
    <div class="login">
      <div class="login_box">
        <div class="login__item">
          <div class="login__name">登录</div>
          <el-form :model="LoginForm" :rules="LoginRules" ref="LoginForm">
            <div class="form__item">
              <div class="item__name">登录帐号</div>
              <div class="inputed__form">
                <el-form-item prop="mobile">
                  <el-input
                    placeholder="请输入您的登录帐号"
                    v-model="LoginForm.mobile"
                    class="el_iput"
                    maxlength="18"
                    autocomplete="off"
                    clearable
                  />
                </el-form-item>
              </div>
            </div>
            <div class="form__item">
              <div class="item__name">登录密码</div>
              <div class="inputed__form">
                <el-form-item prop="password">
                  <el-input
                    placeholder="请输入密码"
                    v-model="LoginForm.password"
                    class="el_iput"
                    type="password"
                  />
                </el-form-item>
              </div>
            </div>
            <!-- <div class="form__item">
              <div class="item__name">验证码</div>
              <div class="inputed__form code__form">
                <el-form-item prop="passcode">
                  <el-input
                    placeholder="请输入验证码"
                    class="el_iput"
                    v-model="LoginForm.passcode"
                  />
                </el-form-item>
                <div class="yan__code" @click.stop="getNewCode">
                  <div class="code__zhi">{{ countCode }}</div>
                </div>
              </div>
            </div> -->

            <div class="pass__list">
              <div class="left_remember" @click.stop="clickRemember">
                <div class="img_changed">
                  <img
                    src="../../assets/img/img_36.png"
                    v-if="remember == 0"
                    alt=""
                  />
                  <img src="../../assets/img/img_13.png" v-else alt="" />
                </div>
                <div
                  class="remember__name"
                  :class="remember == 0 ? '' : 'is_remember'"
                >
                  记住密码
                </div>
              </div>
              <div class="forget_name" @click="forgetPass">忘记密码？</div>
            </div>
            <div class="form__button">
              <el-button class="el__buton" @click="submitForm('LoginForm')"
                >确认登录</el-button
              >
            </div>
          </el-form>
        </div>
      </div>
      <div class="ww__logp">
        <div class="w sf">
          <div class="img__logo" @click="goHome">
            <img
              src="../../assets/img/img_12.png"
              class="img_logo_post"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="请进行人脸识别"
      :visible.sync="dialogVisible"
      width="600px"
      :before-close="handleClose"
      :show-close="true"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div style="text-align: center;">
        <div id="qrcode" ref="qrcode"></div>
		<div class="login__name">请使用微信扫码</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import { mapActions } from "vuex";
// 引入base64
const Base64 = require("js-base64").Base64;
export default {
  data() {
    var validateMobile = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("帐号不能为空"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    return {
      bei_ing: "img_11.png",
      imgSrc: this.Public.imgSrc,
      remember: 0,
      LoginForm: {
        mobile: "",
        password: "",
      },
      LoginRules: {
        mobile: [{ validator: validateMobile, trigger: "blur" }],
        password: [{ validator: validatePass, trigger: "blur" }],
      },
      dialogVisible: false,
      pageUrl: "",
      timer: null,     // 轮询定时器id
      isAuthOk: false,
      t: "",
      f: "",
      statusText: '正在获取二维码...'
    };
  },
  created() {
    // 在页面加载时从cookie获取登录信息
    let mobile = this.getCookie("mobile"),
      remember = this.getCookie("remember"),
      password = Base64.decode(this.getCookie("password"));
    if (remember) {
      // 如果存在赋值给表单，并且将记住密码勾选
      this.LoginForm.mobile = mobile;
      this.LoginForm.password = password;
      this.remember = remember;
    }
    console.log(mobile, password);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  methods: {
    ...mapActions(["userinfo", "isclickLogin"]),
    async fetchUrlAndGenerateQrcode() {
      let that = this;
      try {
        // 1. 获取二维码url
        this.pageUrl = that.f

        // 2. 生成二维码
        this.$nextTick(() => {
          this.createQrcode(this.pageUrl)
          this.statusText = '请微信扫码，等待认证...'
        })

        // 3. 开始每秒轮询认证结果
        this.startPolling()

      } catch (e) {
        console.error('初始化失败：', e)
        this.statusText = '获取二维码失败'
      }
    },

    startPolling() {
      let that = this,
					url = "lists2/face3?token="+that.t,
					param = {};
      if (this.timer) return // 防止重复开启
      this.timer = setInterval(async () => {
        if (this.isAuthOk) return

        try {
          const res = await this.post(url)
          // 假设接口返回 { code:200, success:true } 表示认证完成
          if (res.data && res.data.facestate==3) {
            this.isAuthOk = true
            this.stopPolling()
            this.$message.success('认证完成！') 
            this.statusText = '认证成功，可进行下一步'
            localStorage.setItem("token-qzb", that.t);
              setTimeout(() => {
                let id = localStorage.getItem("id");
                if (id) {
                  localStorage.removeItem("id");
                  this.$router.push({
                    path: "/profile",
                    query: { id: id },
                  });
                } else {
                  // window.history.state.back 存在表示有上一个历史状态
                  if (window.history.state && window.history.state.back) {
                    this.$router.go(-1);
                  } else {
                    // 没有上一页，跳转首页
                    this.$router.push('/');
                  }
                }
              }, 300);
          }
        } catch (e) {
          console.warn('轮询接口异常：', e)
        }
      }, 3000) // 1秒一次
    },

    stopPolling() {
      console.log('停止轮询')
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    // 3. 生成二维码
    createQrcode(url) {
      // 先清空容器，防止重复生成
      this.$refs.qrcode.innerHTML = "";

      new QRCode(this.$refs.qrcode, {
        text: url, // 二维码内容（就是页面url）
        width: 200,
        height: 200,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H, // 容错级别
      });
    },
    handleClose() {
      this.stopPolling()
      this.dialogVisible = false;
    },
    submitForm(formName) {
      let than = this;
      // 登录
      this.$refs[formName].validate((valid) => {
        console.log(formName); // 代表要提交的表单数据 是 LoginForm 对象
        if (valid) {
          console.log(valid, "valid");
          let url = "/lists2/password_login",
            param = {
              username: this.LoginForm.mobile,
              password: this.LoginForm.password,
              type: this.remember,
            };
          
          console.log("提交的信息", param);
          //return;
          this.post(url, param)
            .then((res) => {
              console.log(res);
              if (res.code == 1) {
                than.userinfo(res.data);
                than.t = res.data.token;
                than.f = res.data.face;
				
                if (res.data.face_login!=1) {
                  than.callback2(res);
				  return "";
                }
                if (res.data.image) {
                  than.$message.success(res.msg);
                  than.dialogVisible = true;
                  than.fetchUrlAndGenerateQrcode();
                } else {
                  than.$alert('请先完善个人头像信息', '登录成功', {
                    confirmButtonText: '确认',
                    callback: action => {
                      than.callback2(res);
                    },
                  })
                }
              }
              than.isclickLogin(true);
            })
            .catch((err) => {
              console.log(err);
              this.$message.error(err.msg);
            });
        }
      });
    },
    callback2(res) {
      let than = this;
                      localStorage.setItem("token-qzb", than.t);
					  if (res.data.face_login && res.data.study_id) {
						  than.$router.push({
							path: "/profile",
							query: { id: res.data.study_id },
						  });
                      } else {
						  if (window.history.state && window.history.state.back) {
							than.$router.go(-1);
						  } else {
							// 没有上一页，跳转首页
							than.$router.push('/');
						  }
					  }
    },
    forgetPass() {
      // 忘记密码
      this.$router.push("/forget");
    },
    clickRemember() {
      // 记住密码
      if (this.remember == 1) {
        this.remember = 0;
      } else {
        this.remember = 1;
        this.setUserInfo();
      }
    },
    setUserInfo() {
      // 储存表单信息
      if (this.remember) {
        this.setCookie("mobile", this.LoginForm.mobile);
        let password = Base64.encode(this.LoginForm.password); // base64加密密码
        this.setCookie("remember", this.remember);
        this.setCookie("password", password);
      } else {
        this.setCookie("mobile", "");
        this.setCookie("password", "");
        this.setCookie("remember", "0");
      }
    },
    getCookie(key) {
      // 获取cookie
      if (document.cookie.length > 0) {
        var start = document.cookie.indexOf(key + "=");
        if (start !== -1) {
          start = start + key.length + 1;
          var end = document.cookie.indexOf(";", start);
          if (end === -1) end = document.cookie.length;
          return unescape(document.cookie.substring(start, end));
        }
      }
      return "";
    },
    setCookie(cName, value, expiredays) {
      // 保存cookie
      var exdate = new Date();
      exdate.setDate(exdate.getDate() + expiredays);
      document.cookie =
        cName +
        "=" +
        decodeURIComponent(value) +
        (expiredays == null ? "" : ";expires=" + exdate.toGMTString());
    },
    goHome() {
      this.$router.push("/");
    },
  },
};
</script>

<style lang="less" scoped>
.container__ {
  width: 100%;
  height: 100%;

  .bg__img {
    width: 100%;
    height: 100%; /**宽高100%是为了图片铺满屏幕 */
    z-index: -1;
    position: absolute;
  }

  .login {
    width: 100%;
    height: 100%;

    .login_box {
      width: 400px;
      height: 410px;
      background-color: #fff;
      border-radius: 10px;
      box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;

      .login__item {
        width: 100%;
        padding: 33px 44px;
        box-sizing: border-box;

        .login__name {
          width: 100%;
          text-align: center;
          font-size: 24px;
          font-family: Source Han Sans CN, Source Han Sans CN-Medium;
          font-weight: 500;
          color: #d6a07a;
          line-height: 24px;
          margin-bottom: 30px;
        }

        .form__item {
          width: 100%;
          display: flex;
          align-items: center;
          padding: 28px 0 20px;
          box-sizing: border-box;
          border-bottom: 1px solid #eaeaea;

          .item__name {
            width: 60px;
            font-size: 14px;
            font-family: Source Han Sans CN, Source Han Sans CN-Regular;
            font-weight: 400;
            text-align: left;
            color: #06121e;
            line-height: 24px;
          }

          .inputed__form {
            flex: 1;
            padding-left: 10px;
            box-sizing: border-box;
          }
          .code__form {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .yan__code {
              width: 80px;
              height: 27px;
              background: #eeeeee;

              .code__zhi {
                width: 100%;
                height: 27px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 18px;
                font-family: YouSheBiaoTiHei, YouSheBiaoTiHei-Regular;
                font-weight: 600;
                color: #2d52b1;
              }
            }
          }
        }

        .pass__list {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;

          padding: 40px 0;
          box-sizing: border-box;

          .left_remember {
            display: flex;
            align-items: center;
            .img_changed {
              width: 14px;
              height: 14px;
              margin-right: 5px;

              img {
                width: 100%;
              }
            }

            .remember__name {
              font-size: 14px;
              font-family: Source Han Sans CN, Source Han Sans CN-Regular;
              font-weight: 400;
              text-align: left;
              color: #5b5e63;
              line-height: 24px;
            }

            .is_remember {
              color: #2d52b1;
            }
          }

          .forget_name {
            font-size: 14px;
            font-family: Source Han Sans CN, Source Han Sans CN-Regular;
            font-weight: 400;
            text-align: right;
            color: #5b5e63;
            line-height: 24px;
          }
        }

        .form__button {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          .el__buton {
            width: 196px;
            height: 40px;
            background: #2d52b1 !important;
            border-radius: 20px;
            font-size: 16px;
            font-family: Source Han Sans CN, Source Han Sans CN-Medium;
            font-weight: 500;
            color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }

    .ww__logp {
      width: 100%;

      .sf {
        position: relative;

        .img__logo {
          width: 100%;
          position: absolute;
          top: 70px;
          z-index: 2;

          .img_logo_post {
            // width: 180px;
            height: 65px;
          }
        }
      }
    }
  }
}
.qrcode-box {
  text-align: center;
  padding: 20px;
}
#qrcode {
  display: inline-block;
  margin-top: 10px;
}
</style>
